module.exports = __webpack_public_path__ + "static/img/yytx01.1a25963.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx01.png
// module id = 873
// module chunks = 0